import { render } from "./TestEmailComponent.vue?vue&type=template&id=c4bc0458"
import script from "./TestEmailComponent.vue?vue&type=script&lang=js"
export * from "./TestEmailComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__